import React from 'react';
import styled, { css } from 'styled-components';
import { MediaQueries } from '../../util/MediaQueries';

interface HeadingProps {
  tag: 'h1' | 'h2' | 'h3';
  text: React.ReactNode;
  size: 's' | 'm' | 'l' | 'xl' | 'xxl';
  style?: Object;
}

interface HeadingSize {
  size: HeadingProps['size'];
}

const getSize = (size: HeadingProps['size']) => {
  switch (size) {
    case 's':
      return Small;
    case 'm':
      return Medium;
    case 'l':
      return Large;
    case 'xl':
      return ExtraLarge;
    case 'xxl':
      return XExtraLarge;
  }
};

const Heading: React.FC<HeadingProps> = ({ tag, text, size, style }) => {
  switch (tag) {
    case 'h1':
      return (
        <H1 size={size} style={style}>
          {text}
        </H1>
      );
    case 'h2':
      return (
        <H2 size={size} style={style}>
          {text}
        </H2>
      );
    case 'h3':
      return (
        <H3 size={size} style={style}>
          {text}
        </H3>
      );
  }
};

export default Heading;

const H1 = styled.h1<HeadingSize>`
  ${props => getSize(props.size)}
`;

const H2 = styled.h2<HeadingSize>`
  ${props => getSize(props.size)}
`;

const H3 = styled.h3<HeadingSize>`
  ${props => getSize(props.size)}
`;

const Small = css`
  font-size: 22px;
  line-height: 28px;
  ${MediaQueries.onlyMobile} {
    font-size: 14px;
    line-height: 28px;
  }
`;

const Medium = css`
  font-size: 32px;
  line-height: 38px;
  ${MediaQueries.onlyMobile} {
    font-size: 22px;
    line-height: 28px;
  }
`;

const Large = css`
  font-size: 36px;
  line-height: 44px;
  ${MediaQueries.onlyMobile} {
    font-size: 24px;
    line-height: 32px;
  }
`;

const ExtraLarge = css`
  font-size: 48px;
  line-height: 56px;
  ${MediaQueries.onlyMobile} {
    font-size: 32px;
    line-height: 40px;
  }
`;

const XExtraLarge = css`
  font-size: 60px;
  line-height: 66px;
  ${MediaQueries.onlyMobile} {
    font-size: 36px;
    line-height: 44px;
  }
`;
